import axios from 'axios';
import { EnhancedWithAuthHttpService } from './http-auth.service';
import { HttpService } from './http.service';
import { MockDB, MockHttpClient } from './mock-http.service';

const axiosWithCredentials = axios.create({
  withCredentials: true
});

export class HttpFactoryService {
  createHttpService(): HttpService {
    return new HttpService(axiosWithCredentials);
  }

  createAuthHttpService() {
    return new EnhancedWithAuthHttpService(this.createHttpService());
  }
}
